import React from 'react'

import Logo from 'components/common/Logo'

import * as Styles from './styles'

const OhBackground = props => {
    return (
        <Styles.Wrapper>
            <Styles.Logo
                href={process.env.REACT_APP_WEBSITE_URL}
                rel="noopener"
                target="_blank"
            >
                <Logo width={6} />
            </Styles.Logo>
            {props.children}
        </Styles.Wrapper>
    )
}

export default OhBackground
